<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
}
.header-custome {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.knowlg-base-wrap-sec a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
}
.knowlg-base-wrap-sec a span{margin-right: 10px; line-height: 0;}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h2>User Journey</h2>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-analytics/question-1"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></span> Need help with this section?</a>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ pageViewUserData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : pageViewUserData.length }} of {{ pageViewUserData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>-->
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD Attendee-->

        <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
          Subject:
          <h3>{{welcomeMailSubject}}</h3>
          <br />
          <div v-html="welcomeMailText"></div>
          <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
          <br />
          <div click="sendbtn-section">
            <vs-button color="rgb(76, 139, 246)" type="filled" @click="popupActiveMail=false">Cancel</vs-button>
            <!--<vs-button class="mail-btn" type="gradient" @click="sendMail">Send Mail</vs-button>-->
          </div>
        </vs-popup>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
  <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-42"
          >
            <span class="mr-2 leading-none" v-if="filtrDay == 0"><small>Filter : 24 hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay > 0"><small>Filter : {{filtrDay}} days</small></span>
             <span class="mr-2 leading-none" v-else-if="filtrHours > 0"><small>Filter : {{filtrHours}} hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay == -1"><small>Filter : All</small></span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
              <vs-dropdown-item @click="changeFilterByDays(6)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>6 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(12)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>12 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(24)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>24 Hours</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(3)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 3 days</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(7)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 7 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(-1)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>All</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
            <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="exportBulkSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download Bulk CSV Report</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="pageViewUserData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/UserJourneyCellRendererActions.vue";

//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      bulkAnalyticsData: [],
      filtrDay: null,
      filtrHours: null,
      settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      pageView_UserData: [],
      columnDefs: [
        //{
        //  //headerName: 'ID',
        //  field: "AttendeeId",
        //  //width: 40,
        //  filter: false,
        //  checkboxSelection: true,
        //  headerCheckboxSelectionFilteredOnly: true,
        //  headerCheckboxSelection: true
        //},
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Name",
          field: "Uname",
          filter: true,
          width: 400
        },
        {
          headerName: "Total Views",
          field: "TotalViews",
          filter: true,
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              page: "view"
            };
          }
        },
        {
          headerName: "Total Actions",
          field: "TotalActions",
          filter: true,
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              page: "action"
            };
          }
        },
        {
          headerName: "View Details",
          field: "Total",
          filter: true,
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              page: "user_joirney"
            };
          }
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    };
  },
  computed: {
    pageViewUserData() {
      return this.pageView_UserData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    fetch_user_data(filterDayOrhours) {
      this.$vs.loading();
      //console.log(AttendeeId)
      this.$store
        .dispatch("analytics/fetchUserJourneyData",filterDayOrhours)
        .then(res => {
          //debugger;
          this.pageView_UserData = res.data;
          this.$vs.loading.close();
        })
        .catch(err => {
          //debugger;
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
          this.$vs.loading.close();
          console.error(err);
        });
    },
    getSettings() {
      this.$vs.loading();

      this.$store.dispatch("analytics/getSettings").then(res => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];

        datarow.push("Name");
        datarow.push("Total Views");
        datarow.push("Total Actions");
        var userJourneyData = [];
        userJourneyData.push(datarow);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var name = row.Uname == undefined ? "" : row.Uname;
          datarow.push(name);
          var totalViews = row.TotalViews == undefined ? "" : row.TotalViews;
          datarow.push(totalViews);
          var totalActions = row.TotalActions == undefined ? "" : row.TotalActions;
          datarow.push(totalActions);
          userJourneyData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        userJourneyData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "UserJourneyData" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one user journey data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    changeFilterByDays(filterDayOrhours){
       localStorage.setItem("User_Journey_dayOrHour", filterDayOrhours)
        if(filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24){
        this.filtrHours = filterDayOrhours;
        this.filtrDay = null;
      }else if(filterDayOrhours == -1){
        this.filtrDay = -1;
      }else{
          this.filtrDay = filterDayOrhours;
          this.filtrHours = null;
      }
      this.fetch_user_data(filterDayOrhours);
    },
    updateSearchQuery(val) {
     this.gridApi.setQuickFilter(val);
    },
        exportBulkSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 0) {
        this.$vs.loading();
        selectedRows.map((row) => {
          var data = {};
          data.userId = row.UID;
          data.pageName = null
          this.$store
            .dispatch(
              "analytics/fetchAdvanceReportsByUserOrPageName",
              data
            )
            .then((res) => {
              this.bulkAnalyticsData = res.data;
              this.generateBulkReportForAnalytics(this.bulkAnalyticsData);
              this.$vs.loading.close();
            })
            .catch((err) => {
              this.$vs.loading.close();
              console.error(err);
            });
        });
      }else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Bulk Reports",
          text: "Please select atleast one engagement data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
        generateBulkReportForAnalytics(bulkAnalyticsData){
        var datarow = [];
        var timeZone = [];

        timeZone.push("Report Exported In ")
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"'+ timezone + ' Time Zone' + '"');

        datarow.push("Attendee Id");
        datarow.push("Name");
        datarow.push("Email");
        datarow.push("Action");
        datarow.push("Date Time");
        datarow.push("City");
        datarow.push("State");
        datarow.push("Country");
        datarow.push("Operating System");
        datarow.push("Browser");
        var engagementData = [];
        engagementData.push(datarow);
        var TimeZoneHeader = [];
		    TimeZoneHeader.push(timeZone);

        bulkAnalyticsData.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var attendeeId = row.userId == undefined ? "" : row.userId;
          datarow.push('"' + attendeeId + '"');
          var name = row.userName == undefined ? "" : row.userName;
          datarow.push('"' + name + '"');
          var email = row.userEmail == undefined ? "" : row.userEmail;
          datarow.push('"' + email + '"');
          var action = row.actionLabel == undefined ? "" : row.actionLabel;
          datarow.push('"' + action + '"');
          var dtm = row.dateTime == undefined ? "" : row.dateTime;
          datarow.push('"' + dtm + '"');
          var city = row.city == undefined ? "" : row.city;
          datarow.push('"' + city + '"');
          var state = row.state == undefined ? "" : row.state;
          datarow.push('"' + state + '"');
          var country = row.country == undefined ? "" : row.country;
          datarow.push('"' + country + '"');
          var os = row.os == undefined ? "" : row.os;
          datarow.push('"' + os + '"');
          var browser = row.browser == undefined ? "" : row.browser;
          datarow.push('"' + browser + '"');

          engagementData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function(rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        engagementData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "BulkUserEngagementData_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.filtrDay = -1;
    this.changeFilterByDays(-1);
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    //debugger;
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/
    if (!moduleAnalytics.isRegistered) {
      this.$store.registerModule("analytics", moduleAnalytics);
      moduleAnalytics.isRegistered = true;
    }
    //this.$store.dispatch("analytics/fetchUserJourneyData").catch(err => {
    //  //console.error(err)
    //});
    this.fetch_user_data();

    /*let html = "Subject: BNI Cochin Welcomes You to Celebrate Regional Awards & Business Conclave 2020!";
    html += "\n\nHi @@attendee@@, \n\nYou are successfully registered to the Regional Awards & Business Conclave 2020 by BNI Cochin. \nBelow is the link and credentials to login:";
    html += "\n\nLogin URL: https://bni.e2m.live/  \n\nUsername: Registered Email Address \nPin: @@UserPin@@ ";
    html += "\n\nSee you at the Conclave!";
    html +="\n\nThank you,\nTeam e2m OnAir";
    html += "\n\nThis is an auto-generated e-mail. Please do not reply to this e-mail. For any queries or help, please e-mail to support@e2m.live";
    this.welcomeMailText = html;*/
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>